import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroinventario'
})
export class FiltroinventarioPipe implements PipeTransform {

  transform(value: any[], page: number = 0, search: string = '', field: string = 'nombreCompleto'): any[] {
    if (!value || value.length === 0) return []; // Evita errores si `value` es null o vacío
    if (!search) return value.slice(page, page + 100); // Si no hay búsqueda, devuelve los elementos paginados

    return value
      .filter((item: any) => item[field] && typeof item[field] === 'string' && item[field].toLowerCase().includes(search.toLowerCase()))
      .slice(page, page + 100);
  }

}



// WEBPACK FOOTER //
// ./src/pipes/filtroinventario.pipe.ts